import api from './api';
import search from './search';

const service = {
  api,
  search,
};

export default service;


// WEBPACK FOOTER //
// ./src/services/index.js